
export default [
  {
    path: 'characteristic',
    component: resolve => require(['@/views/extra'], resolve),
    name: 'characteristic',
    meta: {
      nav: '标识注册'
    }
  },
  {
    path: 'extraInterface',
    component: resolve => require(['@/views/extra/interface'], resolve),
    name: 'Home',
    keepAlive: true,
    meta: {
      nav: ''
    }
  }
    
]


// WEBPACK FOOTER //
// ./src/router/extra.js